import { useId } from "react";
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, ReferenceLine, CartesianGrid } from "recharts";

export const PASS = 50;
const fmt = (iso) => new Date(iso).toLocaleDateString("en-AU", { day: "numeric", month: "short" });

const Tip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const p = payload[0].payload;
  return (
    <div className="card px-3 py-2 text-xs" style={{ background: "var(--surface)" }}>
      <p className="font-semibold">{p.title}</p>
      <p style={{ color: "var(--ink-3)" }}>{fmt(p.at)} · <span className="font-mono font-bold" style={{ color: p.score >= PASS ? "var(--ok)" : "var(--alert)" }}>{p.score}%</span></p>
    </div>
  );
};

export const GradeChart = ({ data, height = 260, testid }) => {
  const gid = useId().replace(/:/g, "");
  const scores = data.map((d) => d.score);
  const max = Math.max(...scores), min = Math.min(...scores);
  const pts = data.map((d, i) => ({ ...d, n: i + 1 }));
  const off = max <= PASS ? 0 : min >= PASS ? 1 : (max - PASS) / (max - min);
  const flat = max === min;
  const solid = min >= PASS ? "var(--ok)" : "var(--alert)";
  return (
    <div data-testid={testid} style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={pts} margin={{ top: 16, right: 16, left: -16, bottom: 0 }}>
          <defs>
            <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
              <stop offset={off} style={{ stopColor: "var(--ok)" }} />
              <stop offset={off} style={{ stopColor: "var(--alert)" }} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--line)" vertical={false} />
          <XAxis dataKey="n" tick={{ fontSize: 11, fill: "var(--ink-3)" }} tickLine={false} axisLine={false} />
          <YAxis domain={[0, 100]} ticks={[0, 25, 50, 75, 100]} tick={{ fontSize: 11, fill: "var(--ink-3)" }} tickLine={false} axisLine={false} />
          <Tooltip content={<Tip />} />
          <ReferenceLine y={PASS} stroke="var(--ink-3)" strokeDasharray="6 4" label={{ value: "Pass (indicative only)", position: "insideBottomRight", fontSize: 11, fill: "var(--ink-2)" }} />
          <Line type="monotone" dataKey="score" stroke={pts.length > 1 && !flat ? `url(#${gid})` : solid} strokeWidth={2.5}
            dot={({ cx, cy, payload }) => <circle key={payload.n} cx={cx} cy={cy} r={3.5} style={{ fill: payload.score >= PASS ? "var(--ok)" : "var(--alert)" }} />} isAnimationActive />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
